import React from "react";
import { useTranslation } from "react-i18next";

type MultiStepOfVisitProps = {
  steps?: any[];
  currentStep: number;
  setCurrentStep: any;
  currentSubStep: number;
  setCurrentSubStep: any;

};

const MultiStepOfVisit: React.FC<MultiStepOfVisitProps> = ({
  steps,
  currentStep,
  setCurrentStep,
  currentSubStep,
  setCurrentSubStep
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex w-full flex-col gap-4 rounded-2xl bg-primary p-5 text-white">
      <p className="font-semibold">{t("follow_up")}</p>
      <div className="flex w-full flex-col items-start justify-between gap-2">
        {steps?.map((step, index) => {
          const isActive = index === currentStep;
          const isCompleted = index < currentStep;
          const hasSubSteps = (step?.InverseParentSteps?.length ?? 0) > 0;

          return (
            <div
              className={`flex w-full items-center gap-2 ${isActive ? "rounded-full bg-white text-primary" : ""} ${isCompleted && "opacity-80"} ${hasSubSteps?"!rounded-xl":""}`}
              key={index}
            >
              <div
                onClick={() => setCurrentStep(index)}
                className={`flex cursor-pointer flex-col gap-1 pb-1`}
              >
                <div
                  className={`flex  items-center gap-2`}
                >
                  <div
                    className={`border-2 border-primary p-[1px] ${isActive || isCompleted ? "rounded-full border-2 border-white p-[1px]" : ""} `}
                  >
                    <div
                      className={[
                        "flex h-7 w-7 items-center justify-center rounded-full border-2 text-sm font-semibold",
                        isCompleted
                          ? "border-primary bg-white text-primary"
                          : isActive
                            ? "border-primary bg-white text-primary"
                            : "border-white bg-transparent text-white",
                      ].join(" ")}
                    >
                      <div
                        className={`${isActive ? "h-4 w-4 bg-primary" : "h-2 w-2 bg-white"} rounded-full`}
                      />
                    </div>
                  </div>

                  <div className="text-start">
                    <div
                      className={`${isActive || isCompleted ? "font-semibold" : ""}`}
                    >
                      {step.Name}
                    </div>
                  </div>
                </div>


                {/* Sub Steps */}
                {hasSubSteps && (
                  <div
                    className={`w-full overflow-hidden transition-all duration-500 ease-in-out ${isActive ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                      }`}
                  >
                    {step?.InverseParentSteps?.map((sub: any, subIdx: number) => {
                      const isSubCurrent = isActive && currentSubStep === subIdx;
                     

                      const style = isSubCurrent
                        ? " font-semibold text-primary"
                        
                          : "border-primary-textFont text-black";

                      const subNode = (
                        <div
                          key={sub?.Id}
                          onClick={(e) => {
                            e.stopPropagation();
                            setCurrentSubStep(subIdx)
                            //  onStepClick?.(index);
                            //  onSubStepClick?.(subIdx);
                          }}
                          className={`-mb-1 w-full cursor-pointer py-1.5 ps-6 text-sm ${style}`}
                        >
                          {sub.Name}
                        </div>
                      );

                      return sub?.IsVisible && subNode

                    })}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MultiStepOfVisit;
